/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';
import { Paper, PaperProps } from '@mui/material';
import { makeStyles } from '@mui/styles/';
import appTheme from '../theme/appTheme.json';
import Scrollbars from '../layout/Scrollbars';

export const useStyles = makeStyles({
  paper: {
    backgroundColor: appTheme.primaryBackgroundColor,
    color: appTheme.primaryTextColor,
    '& ul': {
      maxHeight: 'unset !important', // the height will be handled by the scroll bar component
    },
  },
  scroll: {
    marginTop: '-1px',
    border: `1px solid ${appTheme.mptLightBlue}`,
    borderBottomRightRadius: '5px',
    borderBottomLeftRadius: '5px',
    borderTopRightRadius: '0px',
    borderTopLeftRadius: '0px',
    boxSizing: 'border-box',
  },
});

const CustomAutocompletePaper = (props: JSX.IntrinsicAttributes & PaperProps) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Scrollbars autoHeight autoHeightMin="30px" autoHeightMax="300px" className={classes.scroll}>
        <Paper {...props} className={classes.paper} square={true} />
      </Scrollbars>
    </React.Fragment>
  );
};

export default CustomAutocompletePaper;
